document.addEventListener('DOMContentLoaded', function () {

    // Read-more toggle
    if (document.querySelector('.read-more') && document.querySelector('.hero-text')) {

        const read_more = document.querySelector('.read-more');
        const hero_text = document.querySelector('.hero-text');
        const mobileHeroQuery = window.matchMedia('(max-width: 992px)');

        function expandHeroText() {
            hero_text.style.maxHeight = hero_text.scrollHeight + 'px';
            hero_text.classList.add('grow');
            read_more.classList.add('is-visible');
            read_more.textContent = ajax_object.readLess;
            read_more.setAttribute('aria-expanded', 'true');
        }

        function collapseHeroText() {
            hero_text.style.maxHeight = null;
            hero_text.classList.remove('grow');
            read_more.classList.remove('is-visible');
            read_more.textContent = ajax_object.readMore;
            read_more.setAttribute('aria-expanded', 'false');
        }

        read_more.setAttribute('aria-expanded', 'false');

        read_more.addEventListener('click', function () {
            if (hero_text.classList.contains('grow')) {
                collapseHeroText();
            } else {
                expandHeroText();
            }
        });

        hero_text.addEventListener('click', function (event) {
            if (!mobileHeroQuery.matches || hero_text.classList.contains('grow')) {
                return;
            }

            if (event.target.closest('a, button')) {
                return;
            }

            expandHeroText();
        });
    }

    // Hero ToC toggle
    var tocToggleButtons = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="hero-toc"]'));

    function setHeroTocState(targetId, isOpen) {
        var target = targetId ? document.getElementById(targetId) : null;

        if (!target) return;

        target.hidden = !isOpen;
        target.classList.toggle('is-open', isOpen);

        tocToggleButtons.forEach(function (control) {
            if (control.getAttribute('aria-controls') !== targetId) return;

            control.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            control.classList.toggle('is-open', isOpen);
        });
    }

    tocToggleButtons.forEach(function (button) {
        var targetId = button.getAttribute('aria-controls');
        var target = targetId ? document.getElementById(targetId) : null;

        if (!target) return;

        button.addEventListener('click', function () {
            setHeroTocState(targetId, button.getAttribute('aria-expanded') !== 'true');
        });
    });

    // Accordion list toggle
    document.querySelectorAll('.faq-card').forEach(card => {
        const header = card.querySelector('.faq-card__header');
        const content = card.querySelector('.faq-card__content');

        if (!header || !content) return;

        header.setAttribute('aria-expanded', header.classList.contains('is-open') ? 'true' : 'false');

        header.addEventListener('click', () => {
            const isOpen = header.classList.contains('is-open');
            const scope = card.closest('.block--accordion-list') || document;

            scope.querySelectorAll('.faq-card__header').forEach(h => {
                h.classList.remove('is-open');
                h.setAttribute('aria-expanded', 'false');
                var parentCard = h.closest('.faq-card');
                if (parentCard) {
                    parentCard.classList.remove('is-open');
                }
            });
            scope.querySelectorAll('.faq-card__content').forEach(c => {
                c.classList.remove('is-active');
                c.style.maxHeight = null;
            });

            if (!isOpen) {
                card.classList.add('is-open');
                header.classList.add('is-open');
                header.setAttribute('aria-expanded', 'true');
                content.classList.add('is-active');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    /* ==========================
       Payments scroller init
       ========================== */

    function initPaymentScroller(root) {
        if (!root || root.dataset.initialized === "1") return;

        var track = root.querySelector(".payment-scroller__track");
        var prev = root.querySelector(".payment-scroller__btn--prev");
        var next = root.querySelector(".payment-scroller__btn--next");

        if (!track || !prev || !next) return;

        var visible = parseInt(root.dataset.visible || "3", 10);
        if (!visible || visible < 1) visible = 3;

        var index = 0;
        root.dataset.initialized = "1";

        function items() {
            return track.children ? Array.prototype.slice.call(track.children) : [];
        }

        function getGapPx() {
            var cs = window.getComputedStyle(track);
            var g = cs.gap || cs.columnGap || "0px";
            var first = (g + "").split(" ")[0];
            var n = parseFloat(first);
            return isNaN(n) ? 0 : n;
        }

        function stepPx() {
            var it = items();
            if (!it.length) return 0;
            var w = it[0].getBoundingClientRect().width;
            return w + getGapPx();
        }

        function maxIndex() {
            var it = items();
            return Math.max(0, it.length - visible);
        }

        function clampIndex() {
            var max = maxIndex();
            if (index < 0) index = 0;
            if (index > max) index = max;
        }

        function update() {
            clampIndex();
            var step = stepPx();
            track.style.transform = "translateX(" + (-index * step) + "px)";
            prev.disabled = index <= 0;
            next.disabled = index >= maxIndex();
        }

        prev.addEventListener("click", function () {
            index -= 1;
            update();
        });

        next.addEventListener("click", function () {
            index += 1;
            update();
        });

        window.addEventListener("resize", update);

        // If images affect widths, update after they load.
        items().forEach(function (node) {
            var img = node.querySelector("img");
            if (img && !img.complete) {
                img.addEventListener("load", update, { once: true });
                img.addEventListener("error", update, { once: true });
            }
        });

        update();
    }

    function initAllPaymentScrollers() {
        var roots = document.querySelectorAll(".payment-scroller.payment-scroller--enabled");
        if (!roots.length) return;
        roots.forEach(initPaymentScroller);
    }

	    initAllPaymentScrollers();
	
	    // Optional for AJAX/dynamic content
	    window.initAllPaymentScrollers = initAllPaymentScrollers;

	    /* ==========================
	       Casino bonus tabs
	       ========================== */

	    function initCasinoBonusTabs(root) {
	        if (!root || root.dataset.bonusTabsInitialized === "1") return;

	        var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-casino-bonus-tab]"));
	        var panels = Array.prototype.slice.call(root.querySelectorAll("[data-casino-bonus-panel]"));
	        var lists = Array.prototype.slice.call(root.querySelectorAll(".casino-card-bonus-list"));
	        var prev = root.querySelector("[data-casino-bonus-prev]");
	        var next = root.querySelector("[data-casino-bonus-next]");
	        var defaultIndex = parseInt(root.getAttribute("data-casino-default-bonus-tab"), 10) || 0;
	        var ticking = false;

	        if (!tabs.length || !panels.length) return;

	        root.dataset.bonusTabsInitialized = "1";

	        function listItems(list) {
	            return list && list.children ? Array.prototype.slice.call(list.children) : [];
	        }

	        function activePanel() {
	            return panels.filter(function (panel) {
	                return !panel.hidden;
	            })[0] || panels[0];
	        }

	        function activeList() {
	            var panel = activePanel();
	            return panel ? panel.querySelector(".casino-card-bonus-list") : null;
	        }

	        function getGapPx(list) {
	            var cs;
	            var gap;
	            var first;
	            var parsed;

	            if (!list) return 0;

	            cs = window.getComputedStyle(list);
	            gap = cs.gap || cs.columnGap || "0px";
	            first = (gap + "").split(" ")[0];
	            parsed = parseFloat(first);

	            return isNaN(parsed) ? 0 : parsed;
	        }

	        function stepPx(list) {
	            var items = listItems(list);

	            if (!items.length) return 0;

	            return items[0].getBoundingClientRect().width + getGapPx(list);
	        }

	        function maxScrollLeft(list) {
	            if (!list) return 0;

	            return Math.max(0, list.scrollWidth - list.clientWidth);
	        }

	        function updateArrows(targetLeft) {
	            var list;
	            var items;
	            var maxLeft;
	            var left;
	            var canScroll;

	            if (!prev || !next) return;

	            list = activeList();
	            items = listItems(list);
	            maxLeft = maxScrollLeft(list);
	            left = typeof targetLeft === "number" ? targetLeft : (list ? list.scrollLeft : 0);
	            canScroll = items.length > 1 && maxLeft > 1;

	            root.classList.toggle("is-bonus-not-scrollable", !canScroll);
	            prev.disabled = !canScroll || left <= 1;
	            next.disabled = !canScroll || left >= maxLeft - 1;
	        }

	        function scrollActiveList(direction) {
	            var list = activeList();
	            var step = stepPx(list);
	            var maxLeft = maxScrollLeft(list);
	            var currentIndex;
	            var targetLeft;

	            if (!list || !step) {
	                updateArrows();
	                return;
	            }

	            currentIndex = Math.round(list.scrollLeft / step);
	            targetLeft = Math.min(maxLeft, Math.max(0, (currentIndex + direction) * step));

	            list.scrollTo({
	                left: targetLeft,
	                behavior: "smooth"
	            });

	            updateArrows(targetLeft);
	        }

	        function setActive(index) {
	            index = Math.max(0, Math.min(panels.length - 1, parseInt(index, 10) || 0));

	            tabs.forEach(function (tab, tabIndex) {
	                var isActive = tabIndex === index;
	                tab.classList.toggle("is-active", isActive);
	                tab.setAttribute("aria-selected", isActive ? "true" : "false");
	            });

	            panels.forEach(function (panel, panelIndex) {
	                var isActive = panelIndex === index;
	                panel.classList.toggle("is-active", isActive);
	                panel.hidden = !isActive;
	            });

	            if (activeList()) {
	                activeList().scrollLeft = 0;
	            }

	            updateArrows(0);
	        }

	        tabs.forEach(function (tab, index) {
	            tab.addEventListener("click", function () {
	                setActive(index);
	            });
	        });

	        if (prev && next) {
	            prev.addEventListener("click", function () {
	                scrollActiveList(-1);
	            });

	            next.addEventListener("click", function () {
	                scrollActiveList(1);
	            });
	        }

	        lists.forEach(function (list) {
	            list.addEventListener("scroll", function () {
	                if (activeList() !== list || ticking) return;

	                ticking = true;
	                window.requestAnimationFrame(function () {
	                    updateArrows();
	                    ticking = false;
	                });
	            }, { passive: true });
	        });

	        window.addEventListener("resize", updateArrows);
	        setActive(defaultIndex);
	    }

	    function initAllCasinoBonusTabs() {
	        var roots = document.querySelectorAll("[data-casino-bonus-tabs]");
	        if (!roots.length) return;
	        roots.forEach(initCasinoBonusTabs);
	    }

	    initAllCasinoBonusTabs();
	    window.initAllCasinoBonusTabs = initAllCasinoBonusTabs;

	    /* ==========================
	       Bonus toplist bonus rails
	       ========================== */

	    function initBonusToplistBonusCarousel(root) {
	        if (!root || root.dataset.bonusToplistBonusInitialized === "1") return;

	        var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-bonus-toplist-bonus-tab]"));
	        var tabList = root.querySelector(".casino-card-bonus-tabs");
	        var list = root.querySelector("[data-bonus-toplist-bonus-list]");
	        var items = list ? Array.prototype.slice.call(list.querySelectorAll("[data-bonus-toplist-bonus-item]")) : [];
	        var prev = root.querySelector("[data-bonus-toplist-bonus-prev]");
	        var next = root.querySelector("[data-bonus-toplist-bonus-next]");
	        var defaultIndex = parseInt(root.getAttribute("data-bonus-default-tab"), 10) || 0;
	        var pendingItemIndex = null;
	        var pendingTabIndex = null;
	        var pendingScrollLeft = null;
	        var pendingTimer = null;
	        var ticking = false;

	        if (!tabs.length || !list || !items.length) return;
	        if (list.clientWidth <= 0 && root.offsetParent === null) return;

	        root.dataset.bonusToplistBonusInitialized = "1";

	        function maxScrollLeft() {
	            return Math.max(0, list.scrollWidth - list.clientWidth);
	        }

	        function maxTabScrollLeft() {
	            return tabList ? Math.max(0, tabList.scrollWidth - tabList.clientWidth) : 0;
	        }

	        function itemLeft(item) {
	            if (!item || !list) return 0;

	            return item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
	        }

	        function targetLeftForItem(item) {
	            return Math.max(0, Math.min(maxScrollLeft(), itemLeft(item)));
	        }

	        function tabIndexFromItem(item) {
	            return item ? parseInt(item.getAttribute("data-bonus-tab-index"), 10) || 0 : 0;
	        }

	        function firstItemForTab(index) {
	            for (var i = 0; i < items.length; i++) {
	                if (tabIndexFromItem(items[i]) === index) return items[i];
	            }

	            return null;
	        }

	        function itemIndexFromScroll() {
	            var left = list.scrollLeft;
	            var index = 0;
	            var closestDistance = Infinity;

	            items.forEach(function (item, itemIndex) {
	                var distance = Math.abs(targetLeftForItem(item) - left);

	                if (distance <= closestDistance + 1) {
	                    closestDistance = distance;
	                    index = itemIndex;
	                }
	            });

	            return index;
	        }

	        function activeTabFromScroll() {
	            return tabIndexFromItem(items[itemIndexFromScroll()] || items[0]);
	        }

	        function clearPendingTarget() {
	            if (pendingTimer) {
	                window.clearTimeout(pendingTimer);
	            }

	            pendingItemIndex = null;
	            pendingTabIndex = null;
	            pendingScrollLeft = null;
	            pendingTimer = null;
	        }

	        function setPendingTarget(item) {
	            pendingItemIndex = Math.max(0, items.indexOf(item));
	            pendingTabIndex = tabIndexFromItem(item);
	            pendingScrollLeft = targetLeftForItem(item);

	            if (pendingTimer) {
	                window.clearTimeout(pendingTimer);
	            }

	            pendingTimer = window.setTimeout(clearPendingTarget, 700);
	        }

	        function pendingTargetReached() {
	            var maxLeft = maxScrollLeft();

	            if (pendingScrollLeft === null) return false;
	            if (Math.abs(list.scrollLeft - pendingScrollLeft) <= 2) return true;
	            if (pendingScrollLeft >= maxLeft - 1 && list.scrollLeft >= maxLeft - 1) return true;

	            return pendingScrollLeft <= 1 && list.scrollLeft <= 1;
	        }

	        function updateArrows(targetLeft) {
	            var maxLeft = maxScrollLeft();
	            var left = typeof targetLeft === "number" ? targetLeft : list.scrollLeft;
	            var canScroll = items.length > 1 && maxLeft > 1;

	            root.classList.toggle("is-bonus-not-scrollable", !canScroll);

	            if (prev) prev.disabled = !canScroll || left <= 1;
	            if (next) next.disabled = !canScroll || left >= maxLeft - 1;
	        }

	        function setActiveTab(index, keepTabVisible) {
	            index = Math.max(0, Math.min(tabs.length - 1, parseInt(index, 10) || 0));

	            tabs.forEach(function (tab) {
	                var isActive = (parseInt(tab.getAttribute("data-bonus-tab-index"), 10) || 0) === index;
	                tab.classList.toggle("is-active", isActive);
	                tab.setAttribute("aria-selected", isActive ? "true" : "false");

	                if (isActive && keepTabVisible) {
	                    keepTabInView(tab);
	                }
	            });

	            updateArrows();
	        }

	        function keepTabInView(tab) {
	            var buffer = 8;
	            var tabLeft;
	            var tabRight;
	            var viewLeft;
	            var viewRight;
	            var nextLeft;

	            if (!tabList || !tab) return;

	            tabLeft = tab.getBoundingClientRect().left - tabList.getBoundingClientRect().left + tabList.scrollLeft;
	            tabRight = tabLeft + tab.offsetWidth;
	            viewLeft = tabList.scrollLeft;
	            viewRight = viewLeft + tabList.clientWidth;
	            nextLeft = viewLeft;

	            if (tabLeft < viewLeft + buffer) {
	                nextLeft = tabLeft - buffer;
	            } else if (tabRight > viewRight - buffer) {
	                nextLeft = tabRight - tabList.clientWidth + buffer;
	            }

	            nextLeft = Math.max(0, Math.min(maxTabScrollLeft(), nextLeft));

	            if (Math.abs(nextLeft - tabList.scrollLeft) > 1) {
	                if (typeof tabList.scrollTo === "function") {
	                    tabList.scrollTo({
	                        left: nextLeft,
	                        behavior: "smooth"
	                    });
	                } else {
	                    tabList.scrollLeft = nextLeft;
	                }
	            }
	        }

	        function scrollToLeft(left) {
	            left = Math.max(0, Math.min(maxScrollLeft(), left));

	            if (typeof list.scrollTo === "function") {
	                list.scrollTo({
	                    left: left,
	                    behavior: "smooth"
	                });
	            } else {
	                list.scrollLeft = left;
	            }

	            updateArrows(left);
	        }

	        function scrollToItem(item, syncTab) {
	            if (!item) return;

	            if (syncTab) {
	                setPendingTarget(item);
	                setActiveTab(pendingTabIndex, true);
	            }

	            scrollToLeft(targetLeftForItem(item));
	        }

	        function scrollByItem(direction) {
	            var currentIndex = pendingItemIndex !== null ? pendingItemIndex : itemIndexFromScroll();
	            var targetIndex = Math.max(0, Math.min(items.length - 1, currentIndex + direction));

	            scrollToItem(items[targetIndex], true);
	        }

	        function syncActiveTabFromScroll() {
	            if (pendingTabIndex !== null) {
	                setActiveTab(pendingTabIndex, true);

	                if (pendingTargetReached()) {
	                    clearPendingTarget();
	                }

	                return;
	            }

	            setActiveTab(activeTabFromScroll(), true);
	        }

	        tabs.forEach(function (tab) {
	            tab.addEventListener("click", function () {
	                var index = parseInt(tab.getAttribute("data-bonus-tab-index"), 10) || 0;

	                scrollToItem(firstItemForTab(index), true);
	            });
	        });

	        if (prev) {
	            prev.addEventListener("click", function () {
	                scrollByItem(-1);
	            });
	        }

	        if (next) {
	            next.addEventListener("click", function () {
	                scrollByItem(1);
	            });
	        }

	        list.addEventListener("wheel", clearPendingTarget, { passive: true });
	        list.addEventListener("touchstart", clearPendingTarget, { passive: true });
	        list.addEventListener("pointerdown", clearPendingTarget);
	        list.addEventListener("keydown", clearPendingTarget);

	        list.addEventListener("scroll", function () {
	            if (ticking) return;

	            ticking = true;
	            window.requestAnimationFrame(function () {
	                syncActiveTabFromScroll();
	                ticking = false;
	            });
	        }, { passive: true });

	        window.addEventListener("resize", function () {
	            clearPendingTarget();
	            updateArrows();
	            setActiveTab(activeTabFromScroll(), true);
	        });

	        scrollToItem(firstItemForTab(defaultIndex) || items[0], true);
	    }

	    function initAllBonusToplistBonusCarousels() {
	        var roots = document.querySelectorAll("[data-bonus-toplist-bonus-carousel]");
	        if (!roots.length) return;
	        roots.forEach(initBonusToplistBonusCarousel);
	    }

	    initAllBonusToplistBonusCarousels();
	    window.initAllBonusToplistBonusCarousels = initAllBonusToplistBonusCarousels;

	    document.addEventListener("click", function (event) {
	        if (!event.target.closest("[data-bonus-toplist-tab]")) return;

	        window.requestAnimationFrame(initAllBonusToplistBonusCarousels);
	    });
	
	    /* ==========================
	       Horizontal content carousel
       ========================== */

    function initHorizontalCarousel(root) {
        if (!root || root.dataset.carouselInitialized === "1") return;

        var trackSelector = root.getAttribute("data-carousel-track");
        var prevSelector = root.getAttribute("data-carousel-prev");
        var nextSelector = root.getAttribute("data-carousel-next");

        if (!trackSelector && root.hasAttribute("data-howto-carousel")) {
            trackSelector = ".timeline-steps-track";
            prevSelector = ".timeline-step-arrow--prev";
            nextSelector = ".timeline-step-arrow--next";
        } else if (!trackSelector && root.hasAttribute("data-info-carousel")) {
            trackSelector = ".info-block__grid";
            prevSelector = ".info-block__arrow--prev";
            nextSelector = ".info-block__arrow--next";
        }

        var track = trackSelector ? root.querySelector(trackSelector) : root.querySelector("[data-carousel-track]");
        var prev = prevSelector ? root.querySelector(prevSelector) : root.querySelector("[data-carousel-prev]");
        var next = nextSelector ? root.querySelector(nextSelector) : root.querySelector("[data-carousel-next]");

        if (!track || !prev || !next) return;

        var index = 0;
        var ticking = false;
        root.dataset.carouselInitialized = "1";

        function items() {
            return track.children ? Array.prototype.slice.call(track.children) : [];
        }

        function getGapPx() {
            var cs = window.getComputedStyle(track);
            var g = cs.gap || cs.columnGap || "0px";
            var first = (g + "").split(" ")[0];
            var n = parseFloat(first);
            return isNaN(n) ? 0 : n;
        }

        function stepPx() {
            var it = items();
            if (!it.length) return 0;
            return it[0].getBoundingClientRect().width + getGapPx();
        }

        function maxScrollLeft() {
            return Math.max(0, track.scrollWidth - track.clientWidth);
        }

        function maxIndex() {
            var step = stepPx();
            if (!step) return 0;
            return Math.ceil(maxScrollLeft() / step);
        }

        function clampIndex(value) {
            return Math.max(0, Math.min(maxIndex(), value));
        }

        function updateButtons(targetLeft) {
            var left = typeof targetLeft === "number" ? targetLeft : track.scrollLeft;
            var maxLeft = maxScrollLeft();

            root.classList.toggle("is-not-scrollable", maxLeft <= 1);
            prev.disabled = left <= 1;
            next.disabled = left >= maxLeft - 1;
        }

        function goTo(value) {
            var step = stepPx();

            index = clampIndex(value);

            if (!step) {
                updateButtons();
                return;
            }

            var targetLeft = Math.min(maxScrollLeft(), index * step);

            track.scrollTo({
                left: targetLeft,
                behavior: "smooth"
            });

            updateButtons(targetLeft);
        }

        function updateFromScroll() {
            var step = stepPx();

            if (!step) {
                updateButtons();
                return;
            }

            if (track.scrollLeft >= maxScrollLeft() - 1) {
                index = maxIndex();
            } else {
                index = clampIndex(Math.round(track.scrollLeft / step));
            }

            updateButtons();
        }

        prev.addEventListener("click", function () {
            goTo(index - 1);
        });

        next.addEventListener("click", function () {
            goTo(index + 1);
        });

        track.addEventListener("scroll", function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
                updateFromScroll();
                ticking = false;
            });
        }, { passive: true });

        window.addEventListener("resize", updateFromScroll);

        items().forEach(function (node) {
            var img = node.querySelector("img");
            if (img && !img.complete) {
                img.addEventListener("load", updateFromScroll, { once: true });
                img.addEventListener("error", updateFromScroll, { once: true });
            }
        });

        updateButtons();
    }

    function initAllHorizontalCarousels() {
        var roots = document.querySelectorAll("[data-horizontal-carousel], [data-howto-carousel], [data-info-carousel]");
        if (!roots.length) return;
        roots.forEach(initHorizontalCarousel);
    }

    initAllHorizontalCarousels();
    window.initAllHorizontalCarousels = initAllHorizontalCarousels;
    window.initAllHowtoCarousels = initAllHorizontalCarousels;
    window.initAllInfoBlockCarousels = initAllHorizontalCarousels;

    // Pros/cons switch
    document.querySelectorAll('.pros-cons-cards').forEach(function (block) {
        var buttons = Array.prototype.slice.call(block.querySelectorAll('[data-pros-cons-target]'));
        var panels = Array.prototype.slice.call(block.querySelectorAll('[data-pros-cons-panel]'));

        if (!buttons.length || !panels.length) return;

        function setActive(target) {
            buttons.forEach(function (button) {
                var isActive = button.dataset.prosConsTarget === target;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            panels.forEach(function (panel) {
                panel.classList.toggle('is-active', panel.dataset.prosConsPanel === target);
            });
        }

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                setActive(button.dataset.prosConsTarget);
            });
        });

        setActive('pros');
    });

});
